import React, { Component }  from 'react';
import Home from '@material-ui/icons/Home';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import PrintIcon from '@material-ui/icons/Print';
const MenuList = [
    {
        label: "Start",
        pathname: "/",
        icon: (<Home/>)
    },
    {
        label: "Stock Transfers",
        pathname: "/stock/transfers",
        icon:(<SwapHorizIcon/>)
    },
    {
        label: "Scan sales codes",
        pathname: "/sales/scan",
        icon: (<LoyaltyIcon />)
    },

];

export default MenuList;